// src/products/dataroom/components/Modals/DeleteConfirmationModal.js
import React from 'react';
import { AlertTriangle } from 'lucide-react';

const DeleteConfirmationModal = ({ 
  isOpen, 
  item, 
  onConfirm, 
  onCancel 
}) => {
  if (!isOpen || !item) return null;

  const handleConfirm = () => {
    onConfirm(item);
  };

  const getModalTitle = () => {
    if (item.is_embedded_folder) {
      return 'Remove Embedded Folder?';
    }
    return 'Delete Item?';
  };

  const getModalMessage = () => {
    if (item.is_embedded_folder) {
      return `Are you sure you want to remove the embedded folder "${item.name}"? This will not delete the original dataroom.`;
    }
    
    if (item.is_folder) {
      return `Are you sure you want to delete "${item.name}"? This will also delete all contents of the folder.`;
    }
    
    return `Are you sure you want to delete "${item.name}"? This action cannot be undone.`;
  };

  const getConfirmButtonText = () => {
    return item.is_embedded_folder ? 'Remove' : 'Delete';
  };

  const getConfirmButtonClass = () => {
    return item.is_embedded_folder 
      ? 'px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700'
      : 'px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="flex items-center mb-4">
          <AlertTriangle className="h-6 w-6 text-red-600 mr-3" />
          <h3 className="text-lg font-semibold text-gray-900">
            {getModalTitle()}
          </h3>
        </div>
        
        <p className="text-gray-600 mb-6">
          {getModalMessage()}
        </p>

        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className={`${getConfirmButtonClass()} transition-colors`}
          >
            {getConfirmButtonText()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;